<template>
  <div class="manage-related-events-container margin-side">
    <div class="btn-back-wrapper">
      <div class="btn-back icon-back" @click="btnBackClick"></div>
    </div>
    <div class="page-title h2-text">Manage Events</div>

    <ManageRelatedEvents v-if="eventId !== -1" :relatedEvents="relatedEvents" :currentEvent="currentEvent" :eventId="eventId"></ManageRelatedEvents>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex';
  import ManageRelatedEvents from '@/components/events/ManageRelatedEvents';

  export default {
    name: 'event-detail-view',
    components: {
      ManageRelatedEvents
    },
    props: {},
    data () {
      return {
        relatedEvents: [],
        currentEvent: null,
        eventId: -1
      }
    },
    methods: {
      btnBackClick () {
        this.$router.go(-1);
      },
      ...mapActions({
        getEventById: 'ACTION_GET_EVENT_BY_ID'
      }),
      ...mapMutations({})
    },
    computed: {
      ...mapGetters({})
    },
    mounted () {
      if (this.$route.params.relatedEvents) {
        this.relatedEvents = this.$route.params.relatedEvents;
        this.eventId = this.$route.params.eventId;
      } else {
        this.getEventById(this.$route.params.eventId).then(response => {
          if (response.message === null) {
            this.currentEvent = response.event;
            this.eventId = response.event.id;
            this.relatedEvents = response.event.relatedEvents;
          }
        });
      }
    },
    created () {
    }
  };
</script>




// WEBPACK FOOTER //
// ManageRelatedEvents.vue?1ebf167d